export default __webpack_public_path__ + "static/media/sacredsmite.b3bb2e65.png";